/* eslint-disable max-len */
export const getOrgPermissions = (database, orgId) => {
  const dbRef = database.ref(`organizations/${orgId}/orgDetails/permissions`)
  return dbRef.get()
      .then((snapshot) => {
        const permissions = snapshot.val()
        return permissions
      }).catch((err) => {
        console.log('error: ', err)
      })
}
